import { ComponentConfig } from "@measured/puck"
import { message, Select } from "antd"
import { useEffect, useState } from "react"
import { fetchCategories, filterOption } from "../../../../external-components"
import { PostGridByCategoryProps, RenderGridTours } from "./RenderConfig"

const SelectCategory = ({ value, onChange }: any) => {
  const [optionCategories, setOptionCategories] = useState<{ value: string; label: string }[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  const fetchCategory = async () => {
    setLoading(true)

    try {
      const response = await fetchCategories("", "undefined")
      setOptionCategories(
        (response as { data: { id: string; attributes: { name: string } }[] }).data.map(
          (category: { id: string; attributes: { name: string } }) => ({
            value: category.id as string,
            label: category.attributes.name,
          }),
        ),
      )
    } catch (err) {
      message.error("Failed to fetch categories. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCategory()
  }, [])

  return (
    <Select
      loading={loading}
      showSearch
      style={{ width: "100%" }}
      placeholder="Select Category"
      filterOption={filterOption}
      options={optionCategories}
      allowClear
      value={value}
      onChange={onChange}
    />
  )
}

const SelectItemsToRender = ({ value, onChange, totalItems }: any) => {
  const items = [3, 6, 9, "All"]
  return (
    <Select value={value} onChange={onChange} style={{ width: "100%" }} placeholder="Select number of items to display">
      {items.map(item => (
        <Select.Option key={item} value={item}>
          {item === "All" ? "All Items" : `${item} Items`}
        </Select.Option>
      ))}
    </Select>
  )
}

export const GridTours: ComponentConfig<PostGridByCategoryProps> = {
  label: "CaoCao | Grid Tours",

  fields: {
    categoryId: {
      type: "custom",
      render: props => (
        <div className="w-full flex flex-col gap-3">
          <p>Select category to show tour</p>
          <SelectCategory {...props} />
        </div>
      ),
    },
    colorPrimaryTag: {
      type: "text",
      label: "Color Primary Tag",
    },
    isAutoPlay: {
      type: "radio",
      label: "Auto Play",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    isLoopImage: {
      label: "Loop Image",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    showSearch: {
      label: "Show Search",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    showTitle: {
      label: "Show Title (Trips)",
      type: "radio",
      options: [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
    itemsToRender: {
      type: "custom",
      label: "Items to Render",
      render: props => (
        <div className="w-full flex flex-col gap-3">
          <p>Choose number of items to display</p>
          <SelectItemsToRender {...props} />
        </div>
      ),
    },
  },
  defaultProps: {
    categoryId: undefined,
    isAutoPlay: false,
    isLoopImage: false,
    showSearch: true,
    showTitle: true,
    itemsToRender: 3,
  },
  ...RenderGridTours,
}
